import { EyeIcon, PencilIcon } from "@heroicons/react/outline";
import Button from "components/button"
import { SwitchButton } from "components/switchButton"
import { IConditionItem } from "interfaces";
import { Link } from "react-router-dom"
import { isHaveActionPermission } from "utills/helpers";

interface ConditionTableProps {
  data?: IConditionItem[];
  pageSize: number;
  currentPage: number;
  _toggleActive: (id: string, isActive: boolean) => void;
}

export const ConditionTable = ({data = [], _toggleActive, currentPage, pageSize }: ConditionTableProps) => {

  return (
    <div className="flow-root">
      <div className="overflow-x-auto">
        <div className="relative inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
                >
                  No
                </th>
                <th scope="col" className="th">
                  Title (en)
                </th>
                <th scope="col" className="th">
                  Title (vi)
                </th>
                <th scope="col" className="th">
                  Status
                </th>
                <th scope="col" className="th">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {data.map((condition: IConditionItem, index: number) => (
                <tr key={index}>
                  <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                    {(currentPage - 1) * pageSize + 1 + index}
                  </td>
                  <td className="td">{condition.title_en}</td>
                  <td className="td">{condition.title_vi}</td>
                  <td className="td">
                    <SwitchButton
                      checked={condition.is_active}
                      disabled={
                        !isHaveActionPermission("about_actiup", "other", "edit")
                      }
                      onChange={() =>
                        _toggleActive(condition.id, condition.is_active)
                      }
                    />
                  </td>
                  <td className="td flex justify-end items-end gap-x-2 py-4 pl-3 pr-4 sm:pr-6 lg:pr-8">
                    <Link to={`/other/about-actiup/${condition.id}`} className="w-fit">
                      <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                        <EyeIcon className="w-4 h-4 text-black" />
                      </Button>
                    </Link>
                    {isHaveActionPermission("about_actiup", "other", "edit") ? (
                      <Link
                        to={`/other/about-actiup/${condition.id}/edit`}
                        className="w-fit"
                      >
                        <Button className="w-8 h-8 bg-gray-200 hover:bg-gray-100 active:bg-gray-300">
                          <PencilIcon className="w-4 h-4 text-black" />
                        </Button>
                      </Link>
                    ) : (
                      <></>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}